/**
 * StatusBadge — shared shell for the compact status badges used by the
 * procurement / work-order modules (requisitions, purchase orders, work
 * orders). Each module keeps its own status→style map because the lifecycle
 * vocabularies are distinct and shouldn't merge; this primitive owns only the
 * layout + typography, so a token tweak lands in one place.
 *
 * Distinct from StatusPill (different sizing / weight): adopting one for the
 * other's consumers would be a visual change, deliberately not done here.
 */
export interface StatusBadgeMeta {
  label: string;
  /** Tailwind bg / text / border classes for this status. */
  cls: string;
}

export default function StatusBadge({ meta }: { meta: StatusBadgeMeta }) {
  return (
    <span
      className={`inline-block text-[10px] font-bold uppercase tracking-widest px-2 py-0.5 rounded border ${meta.cls}`}
    >
      {meta.label}
    </span>
  );
}
